import React, { useState, useEffect } from 'react';
import MarkdownContent from '../components/MarkdownContent';
import { loadSectionContent, getPersonalInfo } from '../utils/contentLoader';

function Home() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const personalInfo = getPersonalInfo();
  
  useEffect(() => {
    // Set page title
    document.title = personalInfo.name || 'Personal Website';
    
    // Load content for home page sections
    const loadContent = async () => {
      try {
        const loadedSections = await loadSectionContent('home');
        setSections(loadedSections);
      } catch (error) {
        console.error('Error loading home page content:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadContent();
  }, [personalInfo.name]);
  
  if (loading) {
    return (
      <div className="page-loading">
        <div className="loading-spinner"></div>
        <span>Loading...</span>
      </div>
    );
  }
  
  return (
    <div className="home-page">
      <div className="container">
        {/* Removed hero section with name, title and tagline as requested */}
        
        {sections.map((section, index) => (
          <section key={index} className={`content-section ${section.id || ''}`}>
            {section.title && <h1>{section.title}</h1>}
            <MarkdownContent content={section.content} />
          </section>
        ))}
      </div>
    </div>
  );
}

export default Home;
